import type { ReactNode } from "react";
import { ApiClientError, ApiNetworkError } from "../lib/api-client";

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      {children}
    </div>
  );
}

/** Turns an unknown error (typically from a failed query/mutation) into a readable message. */
export function describeError(error: unknown): string {
  if (error instanceof ApiClientError) {
    return error.message || `Request failed (${error.code}).`;
  }
  if (error instanceof ApiNetworkError) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Something went wrong. Please try again.";
}

export function ErrorBanner({
  error,
  onRetry,
  title = "Something went wrong",
}: {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}) {
  return (
    <div className="alert alert--danger" role="alert">
      <strong>{title}</strong>
      <p>{describeError(error)}</p>
      {onRetry && (
        <button type="button" className="btn btn-secondary btn-sm" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
